function slideromens($slider) {
  $slider.each(function() {
    const $container      = $(this)
    const $slidesImages   = $container.find('.js-slides-images');
    const $slidesContent  = $container.find('.js-slides-content');
    const $sliderPrev     = $container.find('.slider__prev');
    const $sliderNext     = $container.find('.slider__next');
    
    $slidesImages.slick({
      dots: false,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '25vw',
      prevArrow: $sliderPrev,
      nextArrow: $sliderNext,
      asNavFor: $slidesContent,
      draggable: false,
      swipe: false,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            centerPadding: '20vw'
          }
        },
        {
          breakpoint: 767,
          settings: {
            centerPadding: '10vw'
          }
        }        
      ]
    });
    
    $slidesContent.slick({
      dots: false,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '25vw',
      prevArrow: $sliderPrev,
      nextArrow: $sliderNext,
      asNavFor: $slidesImages,
      draggable: false,
      swipe: false,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            centerPadding: '20vw'
          }
        },
        {
          breakpoint: 767,
          settings: {
            centerPadding: '10vw'
          }
        }        
      ]
    });
  });
}

slideromens($('.slider-womens'));
